/**
 * The product demo video, as published. It is rendered from the real desktop app by
 * `tools/demo-video` (16:9 and 9:16, English and Hindi); the rendered files are not committed and
 * this repository does not host them, so a cut appears on the website only once it is uploaded and
 * its YouTube id is written here. With no id, the website renders nothing for it.
 *
 * The website embeds it from youtube-nocookie.com behind a click-to-load poster: no YouTube
 * request is made until the visitor presses play.
 */
/** The Hindi 16:9 cut (`tools/demo-video`, `wide-hi`). */
export const hindiDemoVideo = {
    language: 'hi',
    title: 'हिंदी में डेमो देखें',
    description: 'ट्रिप बुकिंग से पार्टी के बकाया और गाड़ियों के काग़ज़ तक — Transport Book असली स्क्रीन पर।',
    // Owner: upload out/transport-book-demo-wide-hi.mp4 and put its YouTube id here.
    youtubeId: undefined,
};
/** True when a cut has a usable YouTube id. */
export function isPublishedVideo(video) {
    return typeof video.youtubeId === 'string' && /^[A-Za-z0-9_-]{11}$/.test(video.youtubeId);
}
//# sourceMappingURL=demoVideo.js.map